export const DEFAULT_TIMEOUT = 100000;
export const AXIOS_TIMEOUT_ERROR_MESSAGE =
  'An error occurred while processing your request. Please verify your input or try again later.';
